var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['progress', _vm.hasTrackableContent && 'progress--light']},[_c('span',{class:[
      'progress__label',
      _vm.isPlaylistCompleted && 'progress__label--complete' ]},[_vm._v("\n    "+_vm._s(_vm.playlistStatusLabel)+"\n  ")]),(_vm.showProgress)?_c('span',{staticClass:"progress__percentage"},[_vm._v("\n    "+_vm._s(_vm.progressLabel)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }